const FleetCardType = {
  DriverSpecific: "driver-specific",
  VehicleSpecific: "vehicle-specific",
  DriverVehicleSpecific: "driver-vehicle-specific",
};

export default FleetCardType;
